import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", { class: "title is-5" }, " Main info ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SField = _resolveComponent("SField")!
  const _component_STextarea = _resolveComponent("STextarea")!
  const _component_STags = _resolveComponent("STags")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SField, {
      modelValue: _ctx.survey.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.survey.name) = $event)),
      label: "Name",
      name: "surveyName",
      maxlength: "50",
      class: "is-small",
      placeholder: "e.g Frontend junior developer",
      required: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_STextarea, {
      modelValue: _ctx.survey.description,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.survey.description) = $event)),
      class: "is-small",
      placeholder: "e.g HTML knowledge survey for junior frontend developer",
      label: "Description",
      required: ""
    }, null, 8, ["modelValue"]),
    _withDirectives(_createVNode(_component_SField, {
      modelValue: _ctx.survey.time,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.survey.time) = $event)),
      label: "Time",
      name: "surveyName",
      maxlength: "50",
      class: "is-small",
      placeholder: "hh:mm"
    }, null, 8, ["modelValue"]), [
      [_directive_mask, '##:##']
    ]),
    _createVNode(_component_STags, {
      modelValue: _ctx.survey.tagsList,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.survey.tagsList) = $event)),
      "tags-list": _ctx.tagsList,
      "onUpdate:tags-list": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tagsList) = $event)),
      label: "Tags",
      "show-create-tag-button": ""
    }, null, 8, ["modelValue", "tags-list"]),
    _createVNode(_component_STags, {
      modelValue: _ctx.survey.skillsList,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.survey.skillsList) = $event)),
      "tags-list": _ctx.skillsList,
      "onUpdate:tags-list": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.skillsList) = $event)),
      label: "Skills",
      "show-create-tag-button": ""
    }, null, 8, ["modelValue", "tags-list"])
  ]))
}